"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccamonfina": {
    "150b4f68": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "skipSearch": false
    }],
    "cambali": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0b19cdd": [{
      "hkey": "4a32cb8a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "gallo": [{
      "hkey": "4a32cb8a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roccamonfina"
    }],
    "df22cfc3": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "skipSearch": false
    }],
    "giglioli": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d1e214a0": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "skipSearch": false
    }],
    "surienza": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c923bb3": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "skipSearch": false
    }],
    "tuorischi": [{
      "hkey": "25b4ca6f",
      "slug": "roccamonfina",
      "name": "Roccamonfina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;